import { Text, Box, Image } from "@chakra-ui/react";
import type { IconProps } from "@chakra-ui/react";
import dynamic from "next/dynamic";

export interface ReqlameAquiProps {
  status: string;
  score: number;
}

const ReqlameAquiLogo = dynamic<IconProps>(() => import("./icons").then((mod) => mod.ReqlameAquiLogo));

export const ReqlameAqui = ({ status, score }: ReqlameAquiProps) => (
  <Box>
    <Image
      display="inline-block"
      boxSize={6}
      src="https://img.airhelp.com/i/icons/reqlameAqui-good.svg"
      alt="Reclame Aqui"
      mb="-6px"
    />
    <Box display="inline-block" fontFamily="Open Sans,Sans-Serif" color="black">
      <Text as="span" fontWeight="black" fontSize="sm" color="inherit">
        {status} {score}
      </Text>
      {score && (
        <Text as="span" display="inline-block" fontSize="10px" mt="0.5" verticalAlign="text-top" color="inherit">
          /10
        </Text>
      )}
    </Box>
    <ReqlameAquiLogo height="18px" width="auto" ml="0.5" />
  </Box>
);
